// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__2oIMc","pillValue":"Pill_pillValue__jqzIo","broken":"Pill_broken__kksFt"};